export default __webpack_public_path__ + "static/media/bear.42565b36.png";